import { render, staticRenderFns } from "./ShopCartPopper.vue?vue&type=template&id=3e57a2e0&"
import script from "./ShopCartPopper.vue?vue&type=script&lang=js&"
export * from "./ShopCartPopper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports